<glxy-page [pagePadding]="false" [mobileMaxWidth]="0">
  @if (showToolbarOnMobile() || !isMobile) {
    <glxy-page-toolbar [showNavToggle]="isOverlay()">
      @if (!isOverlay()) {
        <glxy-page-nav>
          <glxy-page-nav-button [useHistory]="true"></glxy-page-nav-button>
        </glxy-page-nav>
        <glxy-page-title>
          {{ 'INBOX.HEADER.AI_ASSISTANT_INBOX_TITLE' | translate }}
          &nbsp;
          <mat-form-field size="small" subscriptSizing="dynamic" class="assistant-select-field">
            <mat-select (selectionChange)="assistantSelected($event.value)" [value]="assistantId()">
              @let assistants = customAssistants$ | async;
              @for (assistant of assistants; track assistant.id) {
                <mat-option [value]="assistant.id">{{ assistant.name }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </glxy-page-title>
      } @else {
        <glxy-page-title>
          <span>{{ assistant().name }}</span>
          <glxy-badge class="hide-on-mobile beta-badge" color="blue-solid">
            {{ 'INBOX.HEADER.BETA' | translate }}
          </glxy-badge>
        </glxy-page-title>
      }
      <glxy-page-actions>
        @if (!isOverlay()) {
          <button mat-stroked-button [routerLink]="[$configureAssistantRoute()]" class="configure-button">
            <span class="label">{{ 'INBOX.CONFIGURE' | translate }}</span>
          </button>
        } @else {
          <button mat-icon-button class="menu-icon close" (click)="closeOverlay()">
            <mat-icon>close</mat-icon>
          </button>
        }
      </glxy-page-actions>
    </glxy-page-toolbar>
  }
  <div class="inbox-container">
    <div class="inbox-panes">
      @if (!isMobile) {
        <div class="inbox-left-pane">
          <inbox-grouped-conversation-list [rootChatPath]="rootChatPath()"></inbox-grouped-conversation-list>
        </div>
      }
      @if (isMobile && !conversationIdInRoute()) {
        <inbox-grouped-conversation-list [rootChatPath]="rootChatPath()"></inbox-grouped-conversation-list>
      }
      @if (!isMobile || conversationIdInRoute()) {
        <inbox-conversation-view
          [isLoading]="loadingConversations() && !conversationIdInRoute()"
        ></inbox-conversation-view>
      }
    </div>
  </div>
</glxy-page>
